import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { Inputfiledsbase } from '../../models/inputfiledsbase';
import { DropdownQuestion } from '../../question-dropdown';
import { TextboxQuestion } from '../../question-textbox';
import { DropdownservicesService } from '../../../Services/Apis/Dropdownservices/dropdownservices.service';

@Injectable({
  providedIn: 'root',
})
export class CareersService {
  departmentlist: any = [];
  employDroplist: any = [];
  constructor(private dropdownservice: DropdownservicesService) {
    // this.dropdownservice.getdepartmentdrop().subscribe((depart: any) => {
    //   for (let i = 0; i <= depart?.length; i++) {
    //     this.departmentlist?.push({
    //       id: depart[i]?.id,
    //       key: depart[i]?.department_name,
    //       value: depart[i]?.id,
    //     });
    //   }
    // });
    // this.dropdownservice
    //   .getlookupcodesdropdown('EMPLOYMENT_TYPES')
    //   .subscribe((employType: any) => {
    //     for (let i = 0; i <= employType?.length; i++) {
    //       this.employDroplist?.push({
    //         id: employType[i]?.id,
    //         key: employType[i]?.name,
    //         value: employType[i]?.id,
    //       });
    //     }
    //   });
  }

  getJobPostingform() {
    this.dropdownservice.getdepartmentdrop().subscribe((depart: any) => {
      for (let i = 0; i < depart?.length; i++) {
        this.departmentlist?.push({
          id: depart[i]?.id,
          key: depart[i]?.department_name,
          value: depart[i]?.id,
        });
      }
    });
    this.dropdownservice
      .getlookupcodesdropdown('EMPLOYMENT_TYPES')
      .subscribe((employType: any) => {
        for (let i = 0; i < employType?.length; i++) {
          this.employDroplist?.push({
            id: employType[i]?.id,
            key: employType[i]?.name,
            value: employType[i]?.id,
          });
        }
      });
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'position_name',
        label: 'Position Name',
        required: true,
        order: 1,
        placeholder: 'Enter position name',
      }),

      new TextboxQuestion({
        key: 'experience_in_years',
        label: 'Experience',
        required: true,
        order: 2,
        placeholder: 'e.g. 2 years',
        type: 'number',
      }),

      new DropdownQuestion({
        key: 'department_id',
        label: 'Department',
        options: this.departmentlist,
        required: true,
        order: 3,
        placeholder: 'Select department',
      }),
      new DropdownQuestion({
        key: 'employment_type_id',
        label: 'Employment Type',
        options: this.employDroplist,
        required: false,
        order: 4,
      }),
      new TextboxQuestion({
        key: 'salary',
        label: 'Salary Range',
        required: false,
        order: 4.5,
        type: 'text',
        placeholder: 'e.g. 20000-40000',
      }),
      new TextboxQuestion({
        key: 'number_of_openings',
        label: 'No. Of Openings',
        required: false,
        order: 5,
        type: 'number',
        placeholder: 'Enter number of openings',
      }),
      new TextboxQuestion({
        key: 'mode_of_work',
        label: 'Mode Of Work',
        required: false,
        order: 6,
        placeholder: 'e.g. Remote/Onsite/Hybrid',
      }),

      new TextboxQuestion({
        key: 'location',
        label: 'Location',
        required: false,
        order: 7,
        placeholder: 'Enter job location',
      }),
      new TextboxQuestion({
        key: 'phone_number',
        label: 'Mobile Number',
        required: false,
        type: 'number',
        patterns: '^[6-9]\\d{9}$',
        order: 8,
        placeholder: 'Enter 10-digit mobile number',
      }),
      new TextboxQuestion({
        key: 'email',
        label: 'Email',
        required: true,
        patterns: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
        order: 9,
        placeholder: 'Enter email address',
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
